/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Import_Summary_Nothing_Imported_TitleInputs */

const en_ui_import_summary_nothing_imported_title = /** @type {(inputs: Ui_Import_Summary_Nothing_Imported_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing imported`)
};

const de_ui_import_summary_nothing_imported_title = /** @type {(inputs: Ui_Import_Summary_Nothing_Imported_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nichts importiert`)
};

/**
* | output |
* | --- |
* | "Nothing imported" |
*
* @param {Ui_Import_Summary_Nothing_Imported_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_import_summary_nothing_imported_title = /** @type {((inputs?: Ui_Import_Summary_Nothing_Imported_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Import_Summary_Nothing_Imported_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_import_summary_nothing_imported_title(inputs)
	return de_ui_import_summary_nothing_imported_title(inputs)
});